import { registerCardTemplate } from "../../../common/common";
import { lazyTemplate } from "../../lazyTemplate";
import { generateIconProp } from "../../../common/icon-selector/IconEditor";

// Eager metadata registration; the render component (SimpleCardView) code-splits
// into its own tpl-simple-card chunk, loaded on demand when the widget renders.
registerCardTemplate({
    id: 'simple-card',
    name: "Simple Card",
    description: 'A simple card widget, with option to configure a background image, an icon , title and a button. The button can invoke any arbitrary action.',
    template: lazyTemplate(() => import(/* webpackChunkName: "tpl-simple-card" */ "./SimpleCardView")),
    icon: generateIconProp('creditCard'),
    complexity: 'easy',
});
